<template>

  <PrimeDataTable
    :title="'Vacation Template'"
    :showFilter="true"
    :searchOption="true"
    :selectAll="true"
    :showDownload="true"
    :showUpload="false"
    :showAdd="true"
    :columnData="columns"
    :data="data"
    @addDiolog="addDiolog()"
    @rowAction="rowActions($event)"
    activity="VacationTemplate"
  />
  <v-dialog persistent v-model="dialog" width="1000px">
    <AddVacationTemplate
      @reload="getVactionTemplateDate()"
      @closeDialog="setFalse()"
      :id="editId"
      :viewType="viewType"
    />
  </v-dialog>
</template>

<script>

import PrimeDataTable from "@/components/PrimeDataTable";
import AddVacationTemplate from "./AddVacationTemplate.vue";
import VacationTemplateService from "@/api/service/VacationTemplate/VacationTemplateService";

export default {
  components: {
    // AutoComplete,
    PrimeDataTable,
    AddVacationTemplate,
  },
  props: [],
  data() {
    return {
      data: [],
      columns: [],
      vacationTemplateData: [],
      date: new Date(),
      editId: null,
      dialog: false,
      viewType: false,
    };
  },
  created() {
    this.loadColumns();
    this.download = true;
    this.search = true;
    this.checkbox = true;
    this.getVactionTemplateDate();
  },
  methods: {
    loadColumns() {
      this.columns = [
        {
          field: "code",
          header: "Code",
          style: { width: "100px", color: "" },
          toolTip: "Code",
          sortfield: true,
        },
        {
          field: "name",
          header: "Name",
          style: { width: "100px", color: "" },
          toolTip: "Name",
          sortfield: true,
        },

        {
          field: "modified",
          header: "Modified",
          style: { width: "100px", color: "" },
          toolTip: "Modified",
          sortfield: true,
        },
        {
          field: "status",
          header: "Status",
          style: { width: "100px", color: "" },
          toolTip: "Status",
          sortfield: true,
        },
        {
          field: "action",
          header: "Action",
          style: { width: "100px", color: "" },
          toolTip: "Action",
          sortfield: true,
          rowActions: [
            { action: "view" },
            { action: "edit" },
          ],
        },
      ];
    },

    setFalse() {
      this.dialog = false;
    },

    rowActions($event) {
      if ($event.type == "view") {
        this.dialog = true;
        this.editId = $event.data.id;
        this.viewType = $event.type;
      }
      if ($event.type == "edit") {
        this.dialog = true;
        this.editId = $event.data.id;
        this.viewType = $event.type;
      }

      if ($event.type == "select") {
        this.dialog = true;
        this.editId = $event.data.id;
        this.viewType = "view";
      }
    },

    async getVactionTemplateDate() {
      let res = await VacationTemplateService.findAll();
      this.data = res;
      console.log(this.data, "dataaaaaaaaa");
    },
    addDiolog() {
      this.dialog = true;
      this.editId = null;
      this.viewType = false;
    },
  },

};
</script>

<style>
</style>